import axios, { AxiosResponse } from "axios";
import { ApiSearchResponse } from "../models/common";
import { ISearchParams, searchParamsInit } from "../models/searchParams";
import { IAddEditDock, IDock } from "../models/dock";
import { IPlausabilityParam, IPlausabilityResponse } from "../models/plausability";

export const addDock = async (dto: IAddEditDock): Promise<AxiosResponse<IDock>> => {
    return await axios.post("/dispatcher/dock", dto);
};

export const changeDock = async (dto: IAddEditDock): Promise<AxiosResponse<IDock>> => {
    return await axios.patch("/dispatcher/dock/change", dto);
};

export const deleteDock = async (id: string): Promise<AxiosResponse<string>> => {
    return await axios.delete(`/dispatcher/dock/${id}`);
};

export const getDock = async (id: string): Promise<AxiosResponse<IDock>> => {
    return await axios.get(`/dispatcher/dock/${id}`);
};

export const searchDocks = async (
    searchParams: ISearchParams = searchParamsInit,
): ApiSearchResponse<IDock> => {
    return await axios.post("/dispatcher/dock/search", searchParams);
};

export const checkPlausability = async (
    dto: IPlausabilityParam,
): Promise<AxiosResponse<IPlausabilityResponse>> => {
    return await axios.post("/dispatcher/booking/checkPlausability", dto);
};

export const getAreas = async (destinationId: string): Promise<AxiosResponse<string[]>> => {
    return await axios.get(`/docks/destination/areas/${destinationId}`);
};

export const getAreasDisp = async (): Promise<AxiosResponse<string[]>> => {
    return await axios.get("/dispatcher/dock/areas");
};
